export default "__VITE_ASSET__BUIeExbW__"